import React from 'react';
import { X, Phone, MessageSquare, Mail, Calendar, Zap } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export default function QuickTouchModal() {
  const {
    showQuickTouch, setShowQuickTouch,
    quickTouchCustomer, setQuickTouchCustomer,
    logTouch, logQuickBundle,
  } = useAppContext();

  if (!showQuickTouch) return null;

  return (
    <div className="modal-overlay" onClick={() => setShowQuickTouch(false)}>
      <div className="modal-sheet" onClick={e=>e.stopPropagation()}>
        <div className="modal-hdr"><h3>Quick Customer Touch</h3><button className="modal-x" onClick={() => setShowQuickTouch(false)}><X size={20}/></button></div>
        <div className="modal-form">
          <div className="form-group">
            <label>Customer Name</label>
            <input type="text" value={quickTouchCustomer} onChange={e => setQuickTouchCustomer(e.target.value)} placeholder="Customer name..." />
          </div>
          <div className="type-btns" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
            {['Call','Text','Email','Appointment'].map(t=>(
              <button key={t} type="button" className="type-btn" onClick={() => {
                if (quickTouchCustomer.trim()) { logTouch(t, quickTouchCustomer); setShowQuickTouch(false); setQuickTouchCustomer(''); }
              }}>
                {t==='Call'?<Phone size={14}/>:t==='Text'?<MessageSquare size={14}/>:t==='Email'?<Mail size={14}/>:<Calendar size={14}/>}
                {t}
              </button>
            ))}
          </div>
          <p className="quick-desc">Or log a full conversation set (3 calls + 2 emails + 1 text):</p>
          <button className="btn-bundle" onClick={() => {
            if (quickTouchCustomer.trim()) { logQuickBundle(quickTouchCustomer); setShowQuickTouch(false); setQuickTouchCustomer(''); }
          }}><Zap size={16}/> Log Full Conversation Bundle</button>
        </div>
      </div>
    </div>
  );
}
